// Nutrition table variant switcher
// Render nutritional table
function renderNutritionTable(nutrition) {
  const container = document.getElementById('nutrition-table');
  if (!container) return;

  if (!nutrition || !nutrition.average_quantity || nutrition.average_quantity.length === 0) {
    container.style.display = 'none';
    return;
  }

  container.style.display = '';

  const per100Unit = nutrition.per_100_unit || 'g';

  let rows = '';
  for (const nutrient of nutrition.average_quantity) {
    rows += `
      <tr>
        <td>${nutrient.name}</td>
        <td>${nutrient.per_serve ?? '-'}</td>
        <td>${nutrient.per_100g ?? '-'}</td>
      </tr>`;

    if (nutrient.children) {
      for (const child of nutrient.children) {
        rows += `
          <tr>
            <td style="padding-left: 20px;">- ${child.name}</td>
            <td>${child.per_serve ?? '-'}</td>
            <td>${child.per_100g ?? '-'}</td>
          </tr>`;
      }
    }
  }

  container.innerHTML = `
    <h5>Nutrition information</h5>
    <p>
      ${nutrition.servings_per_package ? `Servings per package: ${nutrition.servings_per_package}<br>` : ''}
      ${nutrition.serving_size ? `Serving size: ${nutrition.serving_size}` : ''}
    </p>
    <table>
      <thead>
        <tr>
          <th>Average quantity</th>
          <th>Per serve</th>
          <th>Per 100 ${per100Unit}</th>
        </tr>
      </thead>
      <tbody>${rows}</tbody>
    </table>`;
}

// Update the nutritional table on variant change
customElements.whenDefined('variant-selects').then(function() {
  const VariantSelectsClass = customElements.get('variant-selects');
  const originalUpdateVariantInput = VariantSelectsClass.prototype.updateVariantInput;

  VariantSelectsClass.prototype.updateVariantInput = function() {
    originalUpdateVariantInput.call(this);
    
    // Read directly from currentVariant on the element instance
    const variantId = this.currentVariant?.id?.toString();
    if (!variantId) return;

    console.log('Variant changed to:', variantId);

    const nutrition = window.variantNutrition[variantId] ?? window.productNutrition;
    renderNutritionTable(nutrition);
  };
});